module.exports = __webpack_public_path__ + "img/Weapon_157.4ac21271.png";